import { SMART_BLOCK_TYPE } from "./../ricos-content/consts.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers-lazy.js";
const pluginSmartBlock = (config = {}) => {
  return {
    config,
    type: SMART_BLOCK_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginSmartBlock
};
//# sourceMappingURL=viewer-lazy.js.map
